import { extractVueListeners as e, removeClassStyleAttrs as t, returnFirstEl as n, safeConcatStrings as r } from "../../common/utils/index.js";
import { t as i } from "../../_plugin-vue_export-helper-BTgDAbhb.js";
import a from "../avatar/avatar.js";
import o from "../badge/badge.js";
import { DialtoneLocalization as s } from "../../localization/index.js";
import c from "../button/button.js";
import l from "../tooltip/tooltip.js";
import u from "../emoji-text-wrapper/emoji-text-wrapper.js";
import { LEFTBAR_GENERAL_ROW_CONTACT_CENTER_COLORS as d, LEFTBAR_GENERAL_ROW_CONTACT_CENTER_VALIDATION_ERROR as f, LEFTBAR_GENERAL_ROW_ICON_SIZES as p, LEFTBAR_GENERAL_ROW_TYPES as m } from "./general-row-constants.js";
import h from "./leftbar-general-row-icon.js";
import { Fragment as g, createBlock as _, createCommentVNode as v, createElementBlock as y, createElementVNode as b, createTextVNode as x, createVNode as S, mergeProps as C, normalizeClass as w, normalizeStyle as T, openBlock as E, renderSlot as D, resolveComponent as O, resolveDirective as ee, resolveDynamicComponent as k, toDisplayString as A, toHandlers as j, withCtx as M, withDirectives as N, withModifiers as P } from "vue";
import { DtIconAtSign as F, DtIconCalendarClock as I, DtIconContacts as L, DtIconDialbot as R, DtIconExternalLink as z, DtIconHash as B, DtIconHashBold as V, DtIconInbox as H, DtIconLaptop2 as U, DtIconLayoutTemplate as W, DtIconLock as te, DtIconLockFilled as G, DtIconPhone as K, DtIconSparkle as q, DtIconThread as J, DtIconUsers as Y, DtIconWaveform as X } from "@dialpad/dialtone-icons/vue";
//#region recipes/leftbar/general_row/general_row.vue
var Z = new Map([
	[m.INBOX, H],
	[m.CONTACTS, L],
	[m.CHANNELS, B],
	[m.THREADS, J],
	[m.LAUNCHPAD, W],
	[m.LOCKED_CHANNEL, te],
	[m.QUICK_START, q],
	[m.COACHING_GROUP, Y],
	[m.COACHING_CENTER, z],
	["locked channel unread", G],
	["channel unread", V],
	[m.ASSIGNED, F],
	[m.DIGITAL, U],
	[m.SCHEDULED, I]
]), Q = {
	compatConfig: { MODE: 3 },
	name: "DtRecipeGeneralRow",
	components: {
		DtEmojiTextWrapper: u,
		DtBadge: o,
		DtButton: c,
		DtTooltip: l,
		DtIconPhone: K,
		DtIconWaveform: X,
		DtIconDialbot: R,
		DtAvatar: a,
		DtRecipeLeftbarGeneralRowIcon: h
	},
	inheritAttrs: !1,
	props: {
		type: {
			type: String,
			default: "inbox",
			validator: (e) => Object.values(m).includes(e)
		},
		ariaLabel: {
			type: String,
			default: ""
		},
		description: {
			type: String,
			required: !0
		},
		color: {
			type: String,
			default: null,
			validator: (e) => Object.keys(d).includes(e)
		},
		channelSetting: {
			type: String,
			default: null
		},
		hasUnreads: {
			type: Boolean,
			default: !1
		},
		unreadCount: {
			type: String,
			default: null
		},
		unreadMentionCount: {
			type: String,
			default: null
		},
		selected: {
			type: Boolean,
			default: !1
		},
		muted: {
			type: Boolean,
			default: !1
		},
		activeVoiceChat: {
			type: Boolean,
			default: !1
		},
		dndText: {
			type: String,
			default: ""
		},
		hasCallButton: {
			type: Boolean,
			default: !1
		},
		isTyping: {
			type: Boolean,
			default: !1
		},
		iconSize: {
			type: String,
			default: "300",
			validator: (e) => p.includes(e)
		}
	},
	emits: ["call"],
	data() {
		return {
			actionFocused: !1,
			labelWidth: "100%",
			i18n: new s()
		};
	},
	computed: {
		leftbarGeneralRowClasses() {
			return ["d-recipe-leftbar-row", {
				"d-recipe-leftbar-row--no-action": !this.hasCallButton,
				"d-recipe-leftbar-row--has-unread": this.hasUnreads,
				"d-recipe-leftbar-row__unread-count": this.showUnreadCount || this.showUnreadMentionCount,
				"d-recipe-leftbar-row--selected": this.selected,
				"d-recipe-leftbar-row--muted": this.muted,
				"d-recipe-leftbar-row--action-focused": this.actionFocused
			}];
		},
		getIcon() {
			switch (this.type) {
				case m.CHANNELS:
					if (this.hasUnreads) return "channel unread";
					break;
				case m.LOCKED_CHANNEL:
					if (this.hasUnreads) return "locked channel unread";
					break;
			}
			return this.type;
		},
		getIconComponent() {
			return Z.get(this.getIcon);
		},
		isDialbotType() {
			return this.type === m.DIALBOT;
		},
		isContactCenterType() {
			return this.type === m.CONTACT_CENTER;
		},
		contactCenterIconClasses() {
			return ["d-recipe-leftbar-row__icon-cc", d[this.color]];
		},
		avatarSize() {
			return this.iconSize;
		},
		generalRowListeners() {
			return e(this.$attrs);
		},
		getAriaLabel() {
			return this.ariaLabel ? this.ariaLabel : r([
				this.typingTooltip,
				this.description,
				this.unreadCountTooltip,
				this.dndTextTooltip,
				this.activeVoiceChatTooltip
			]);
		},
		hasActions() {
			return this.dndText || this.activeVoiceChat || this.showUnreadCount || this.hasCallButton || this.showUnreadMentionCount;
		},
		showUnreadCount() {
			return !!this.unreadCount && this.hasUnreads;
		},
		showUnreadMentionCount() {
			return !!this.unreadMentionCount && this.hasUnreads;
		},
		hasUnreadCount() {
			return this.unreadCount !== null;
		},
		hasUnreadMentionCount() {
			return this.unreadMentionCount !== null;
		},
		shouldApplyCustomStyleForCountBadge() {
			return this.hasUnreadCount && this.hasUnreadMentionCount;
		},
		shouldApplyCustomStyleForMentionOnly() {
			return this.channelSetting === "always" && !this.hasUnreadCount && this.hasUnreadMentionCount;
		},
		messageCount() {
			return isNaN(this.unreadCount) ? this.unreadCount : Number(this.unreadCount);
		},
		mentionCount() {
			return isNaN(this.unreadMentionCount) ? this.unreadMentionCount : Number(this.unreadMentionCount);
		},
		unreadCountTooltip() {
			return r([this.unreadCount && this.i18n.$t("DIALTONE_UNREAD_MESSAGE_COUNT_TEXT", { unreadCount: this.messageCount }), this.unreadMentionCount && this.i18n.$t("DIALTONE_UNREAD_MENTION_COUNT_TEXT", { unreadCount: this.mentionCount })]);
		},
		dndTextTooltip() {
			return this.dndText && this.i18n.$t("DIALTONE_GENERAL_ROW_DND_TEXT_TOOLTIP");
		},
		activeVoiceChatTooltip() {
			return this.activeVoiceChat && this.i18n.$t("DIALTONE_GENERAL_ROW_ACTIVE_VOICE_CHAT_TEXT");
		},
		callButtonTooltip() {
			return this.i18n.$t("DIALTONE_GENERAL_ROW_CALL_BUTTON_TOOLTIP");
		},
		typingTooltip() {
			return this.isTyping && this.i18n.$t("DIALTONE_TYPING_TEXT");
		}
	},
	watch: { $props: {
		immediate: !0,
		deep: !0,
		async handler() {
			this.validateProps(), await this.$nextTick(), this.adjustLabelWidth();
		}
	} },
	mounted() {
		this.resizeObserver = new ResizeObserver(this.adjustLabelWidth), this.resizeObserver.observe(n(this.$el)), this.adjustLabelWidth();
	},
	beforeUnmount: function() {
		this.resizeObserver.disconnect();
	},
	methods: {
		removeClassStyleAttrs: t,
		validateProps() {
			this.type === m.CONTACT_CENTER && !Object.keys(d).includes(this.color) && console.error(f);
		},
		adjustLabelWidth() {
			this.labelWidth = (n(this.$el)?.querySelector(".d-recipe-leftbar-row__primary")?.clientWidth || 0) - ((n(this.$el)?.querySelector(".d-recipe-leftbar-row__omega")?.clientWidth || 0) + (n(this.$el)?.querySelector(".d-recipe-leftbar-row__alpha")?.clientWidth || 0) + 16) + "px";
		}
	}
}, ne = [
	"data-qa",
	"aria-label",
	"title",
	"href"
], re = { class: "d-recipe-leftbar-row__alpha" }, ie = {
	key: 0,
	class: "d-recipe-leftbar-row__is-typing"
}, ae = {
	key: 0,
	class: "d-recipe-leftbar-general-row__icon",
	"data-qa": "dt-recipe-leftbar-row-icon"
}, oe = {
	key: 2,
	"data-qa": "dt-recipe-leftbar-row-icon"
}, $ = {
	key: 0,
	class: "d-recipe-leftbar-row__omega"
}, se = {
	key: 1,
	class: "d-recipe-leftbar-row__active-voice"
}, ce = {
	key: 3,
	class: "d-recipe-leftbar-row__action",
	"data-qa": "dt-recipe-leftbar-row-action"
};
function le(e, t, n, r, i, a) {
	let o = O("dt-icon-dialbot"), s = O("dt-avatar"), c = O("dt-emoji-text-wrapper"), l = O("dt-tooltip"), u = O("dt-icon-waveform"), d = O("dt-badge"), f = O("dt-icon-phone"), p = O("dt-button"), m = ee("dt-tooltip");
	return E(), y("div", {
		class: w([a.leftbarGeneralRowClasses, e.$attrs.class]),
		style: T(e.$attrs.style),
		"data-qa": "dt-recipe-leftbar-row"
	}, [b("a", C({
		class: "d-recipe-leftbar-row__primary",
		"data-qa": "data-qa" in e.$attrs ? e.$attrs["data-qa"] : "d-recipe-leftbar-row-link",
		"aria-label": a.getAriaLabel,
		title: n.description,
		href: "href" in e.$attrs ? e.$attrs.href : "javascript:void(0)"
	}, a.removeClassStyleAttrs(e.$attrs), j(a.generalRowListeners, !0)), [b("div", re, [n.isTyping ? N((E(), y("div", ie, [...t[3] || (t[3] = [
		b("span", null, null, -1),
		b("span", null, null, -1),
		b("span", null, null, -1)
	])])), [[m, a.typingTooltip]]) : e.$slots.start ? D(e.$slots, "start", { key: 1 }) : e.$slots.left ? D(e.$slots, "left", { key: 2 }) : (E(), y(g, { key: 3 }, [a.isDialbotType ? (E(), y("div", ae, [S(o, { size: "500" })])) : a.isContactCenterType ? (E(), y("div", {
		key: 1,
		class: w(a.contactCenterIconClasses),
		"data-qa": "dt-recipe-leftbar-row-icon"
	}, null, 2)) : (E(), y("div", oe, [S(s, {
		"icon-only": "",
		size: a.avatarSize
	}, {
		icon: M(({ iconSize: e }) => [(E(), _(k(a.getIconComponent), { size: e }, null, 8, ["size"]))]),
		_: 1
	}, 8, ["size"])]))], 64))]), b("div", {
		class: "d-recipe-leftbar-row__label",
		style: T(`flex-basis: ${i.labelWidth}`)
	}, [D(e.$slots, "label", {}, () => [S(c, {
		class: "d-recipe-leftbar-row__description",
		"data-qa": "dt-recipe-leftbar-row-description",
		size: "200"
	}, {
		default: M(() => [x(A(n.description), 1)]),
		_: 1
	})])], 4)], 16, ne), a.hasActions ? (E(), y("div", $, [
		n.dndText ? (E(), _(l, {
			key: 0,
			placement: "top",
			message: a.dndTextTooltip
		}, {
			anchor: M(() => [b("div", {
				ref: "d-recipe-leftbar-row-dnd",
				class: "d-recipe-leftbar-row__dnd",
				"data-qa": "dt-recipe-leftbar-row-dnd"
			}, A(n.dndText), 513)]),
			_: 1
		}, 8, ["message"])) : v("", !0),
		n.activeVoiceChat ? N((E(), y("div", se, [S(u, { size: "300" })])), [[m, a.activeVoiceChatTooltip]]) : a.showUnreadCount || a.showUnreadMentionCount ? (E(), _(l, {
			key: 2,
			message: a.unreadCountTooltip,
			placement: "top"
		}, {
			anchor: M(() => [a.showUnreadCount ? (E(), _(d, {
				key: 0,
				kind: "count",
				type: "bulletin",
				"data-qa": "dt-recipe-leftbar-row-unread-badge",
				class: w(["d-recipe-leftbar-row__unread-badge", { "d-recipe-leftbar-row__unread-count-badge": a.shouldApplyCustomStyleForCountBadge }])
			}, {
				default: M(() => [x(A(n.unreadCount), 1)]),
				_: 1
			}, 8, ["class"])) : v("", !0), a.showUnreadMentionCount ? (E(), _(d, {
				key: 1,
				kind: "count",
				type: "bulletin",
				"data-qa": "dt-recipe-leftbar-row-unread-mention-badge",
				class: w([
					"d-recipe-leftbar-row__unread-badge",
					{ "d-recipe-leftbar-row__unread-mention-count-badge": a.shouldApplyCustomStyleForCountBadge },
					{ "d-recipe-leftbar-row__unread-mention-only-count-badge": a.shouldApplyCustomStyleForMentionOnly }
				])
			}, {
				default: M(() => [x(A(n.unreadMentionCount), 1)]),
				_: 1
			}, 8, ["class"])) : v("", !0)]),
			_: 1
		}, 8, ["message"])) : v("", !0),
		n.hasCallButton ? (E(), y("div", ce, [S(l, {
			message: a.callButtonTooltip,
			placement: "top"
		}, {
			anchor: M(() => [S(p, {
				class: "d-recipe-leftbar-row__action-button",
				"data-qa": "dt-recipe-leftbar-row-action-call-button",
				circle: "",
				size: 100,
				kind: "inverted",
				"aria-label": a.callButtonTooltip,
				onFocus: t[0] || (t[0] = (e) => i.actionFocused = !0),
				onBlur: t[1] || (t[1] = (e) => i.actionFocused = !1),
				onClick: t[2] || (t[2] = P((t) => e.$emit("call", t), ["stop"]))
			}, {
				icon: M(() => [S(f, { size: "200" })]),
				_: 1
			}, 8, ["aria-label"])]),
			_: 1
		}, 8, ["message"])])) : v("", !0)
	])) : v("", !0)], 6);
}
var ue = /* @__PURE__ */ i(Q, [["render", le]]);
//#endregion
export { ue as default };

//# sourceMappingURL=general-row.js.map